import { Model } from "@vuex-orm/core";
import config from "../configs/ResolutionCatalogTag";

export default class ResolutionCatalogTag extends Model {
  static get entity() {
    return "resolution_catalog_tag";
  }
  // static get primaryKey() {
  //   return ["resolution_catalog_id", "tag_id"];
  // }

  static fields() {
    return {
      id: this.attr(null),
      resolution_catalog_id: this.attr(null),
      tag_id: this.attr(null),

      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      agency_id: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
